import { DataGridPro, type GridColDef } from "@mui/x-data-grid-pro";

import { type FC, useMemo } from "react";
import { uuidv4 } from "../../../../utils/uuid";
import type { PollRecipient } from "../context/moment-polls-context";
import { pollContact } from "../utils/poll-contact";

export type DisplayPerson = PollRecipient & { answer?: string };

export const DisplayPersons: FC<{
  persons: DisplayPerson[];
}> = ({ persons }) => {
  const columns = useMemo(
    () =>
      [
        {
          field: "first_name",
          headerName: "First Name",
          flex: 1,
          renderCell: (params) => <>{params.row.first_name || <>-</>}</>,
        },
        {
          field: "last_name",
          headerName: "Last Name",
          flex: 1,
          renderCell: (params) => <>{params.row.last_name || <>-</>}</>,
        },
        {
          field: "destination",
          headerName: "Contact",
          flex: 1,
          valueGetter: (_, row) => pollContact(row),
        },
        {
          field: "answer",
          headerName: "Answer",
          flex: 1,
          renderCell: (params) => <>{params.row.answer || <>-</>}</>,
        },
      ] as GridColDef<DisplayPerson>[],
    [],
  );

  return (
    <DataGridPro
      pagination
      pageSizeOptions={[10, 25, 50, 100]}
      initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
      rows={persons}
      columns={columns}
      disableRowSelectionOnClick
      getRowId={(row) => row.person_id || row.destination || uuidv4()}
      showToolbar
    />
  );
};
